import VimeoPlayer from '@vimeo/player';
import VideoPlayerBase from './video-player-base';

export default class NorthCVimeoPlayer extends VideoPlayerBase {
  static getPlayer(iframe) {
    return new VimeoPlayer(iframe);
  }

  autoplay() {
    this.player.setVolume(0);
    this.player.setMuted(true);
    this.player.setLoop(true);
    this.player.play();
  }

  stop() {
    this.player.pause();
    this.player.setCurrentTime(0);
  }

  play() {
    this.player.play();
  }
}
